// Tiny pushState router glue shared between main.ts (which owns the actual
// render/mount dispatch) and pages that need to navigate programmatically
// (e.g. a popup button jumping to the check-in log). Kept separate from
// main.ts to avoid a circular import (pages -> main -> pages).
let onNavigate: (() => void) | null = null;

export function setNavigateListener(fn: () => void): void {
  onNavigate = fn;
}

export function navigate(path: string): void {
  if (path !== window.location.pathname + window.location.search) {
    window.history.pushState({}, '', path);
  }
  onNavigate?.();
}
